import React, { useEffect } from "react";
import "../../userLayout/userLayout.scss";

const PublicHeader = ({ toggleMobileMenu, mobileMenuOpen }) => {
  useEffect(() => {
    const html = document.documentElement;
    if (mobileMenuOpen) {
      html.classList.add("body-mobile-menu-open");
    } else {
      html.classList.remove("body-mobile-menu-open");
    }
    // Cleanup for when component unmounts
    return () => {
      html.classList.remove("body-mobile-menu-open");
    };
  }, [mobileMenuOpen]);

  return (
    <header className="header">
      <div className="header-info">
        {/* Hamburger menu button for mobile */}
        <button
          className="hamburger-menu d-lg-none"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span
            className={`hamburger-line ${mobileMenuOpen ? "active" : ""}`}
          ></span>
          <span
            className={`hamburger-line ${mobileMenuOpen ? "active" : ""}`}
          ></span>
          <span
            className={`hamburger-line ${mobileMenuOpen ? "active" : ""}`}
          ></span>
        </button>
        {/* Empty user-info div with min-height to maintain header height */}
        <div className="user-info" style={{ minHeight: '34px' }}>
          {/* No notification, no user profile - just empty space to maintain height */}
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
